document.addEventListener('DOMContentLoaded', () => {
    const actionHandlers = {
        jumpforward: handleJumpForward,
        rewind: handleRewind,
    };

    document.querySelector('.j6csq-decision-tool').addEventListener('click', event => {
        const button = event.target.closest('.j6csq-decision-tool-element-button');
        if (!button) return;

        const action = button.dataset.action;
        const target = button.dataset.actionTarget;

        if (action === 'jumpforward') {
            const fromSlide = button.closest('.j6csq-decision-tool-slide');
            const isValid = validateSlide(fromSlide);

            if (!isValid) return; // Stop if validation fails
        }

        actionHandlers[action]?.(button, target);
    });
});

function handleJumpForward(button, target) {
    const targetSlide = document.getElementById(target);
    if (!targetSlide) {
        console.error(`Slide not found: ${target}`);
        alert('Error: Slide not found');
        return;
    }

    const fromSlide = button.closest('.j6csq-decision-tool-slide');
    if (fromSlide) {

        // Remove "chosen path" class from all buttons on the fromSlide
        fromSlide.querySelectorAll('.j6csq-decision-tool-element-button-chosenpath').forEach(btn => {
            btn.classList.remove('j6csq-decision-tool-element-button-chosenpath');
        });

        // Now add it to the button that was clicked
        button.classList.add('j6csq-decision-tool-element-button-chosenpath');

        // Calculate the button's horizontal center relative to the slide
        const buttonRect = button.getBoundingClientRect();
        const slideRect = fromSlide.getBoundingClientRect();
        const buttonCenter = buttonRect.left + buttonRect.width / 2 - slideRect.left;

        // Add the completed class which renders as a dashed vertical line, and dynamically set the background position
        fromSlide.classList.add('j6csq-decision-tool-slide-completed');
        fromSlide.style.backgroundPosition = `${buttonCenter}px bottom`;

        // Loop over all slides which come after the fromSlide in the DOM
        let current = fromSlide.nextElementSibling;
        while (current) {

            // restores content and resets form inputs
            resetSlide(current);

            // Hide the slide
            current.classList.remove('visible', 'j6csq-decision-tool-slide-completed');
            current.setAttribute('aria-hidden', 'true');

            current = current.nextElementSibling;
        }
    }

    // Interpolate input values into text elements on target slide, i.e. {$firstname} gets replaced with the value of the input with id "firstname"
    targetSlide.querySelectorAll('.j6csq-decision-tool-has-interpolated-text').forEach(element => {
        element.innerHTML = element.textContent.replace(/{\$([^}]+)}/g, (_, inputId) => {
            const inputValue = document.getElementById(inputId)?.value || '';
            const escapedValue = escapeHtml(inputValue);
            return escapedValue;
        });
    });

    // Activate the target slide
    targetSlide.setAttribute('aria-hidden', 'false');
    targetSlide.classList.add('visible');
    targetSlide.scrollIntoView({ behavior: 'smooth', block: 'start' });
    targetSlide.querySelector('h2')?.focus();

    document.getElementById('live-announcements').textContent =
        `Now viewing slide: ${targetSlide.querySelector('h2')?.textContent || 'Slide'}`;

    document.dispatchEvent(new CustomEvent('slideActivated', { detail: { slideId: targetSlide.id } }));
}

function escapeHtml(unsafe) {
    const div = document.createElement('div');
    div.textContent = unsafe;
    return div.innerHTML.replace(/"/g, '&quot;');
}

function handleRewind(button, target) {
    const targetSlide = document.getElementById(target);
    if (!targetSlide) {
        console.error(`Slide not found: ${target}`);
        alert('Error: Slide not found');
        return;
    }

    const fromSlide = button.closest('.j6csq-decision-tool-slide');

    // Remove chosen path button class on rewind
    fromSlide.querySelectorAll('.j6csq-decision-tool-element-button-chosenpath').forEach(btn => {
        btn.classList.remove('j6csq-decision-tool-element-button-chosenpath');
    });

    // Reset and hide all slides after the target slide
    let current = fromSlide;
    while (current && current !== targetSlide) {

        // restores content and resets form inputs
        resetSlide(current);

        // Hide the slide
        current.classList.remove('visible', 'j6csq-decision-tool-slide-completed');
        current.setAttribute('aria-hidden', 'true');
       
        current = current.previousElementSibling;
    }

    // Ensure the target slide itself is reset
    targetSlide.classList.remove('j6csq-decision-tool-slide-completed');
    const form = targetSlide.querySelector('form');
    if (form) form.reset();

    // Activate the target slide
    document.querySelectorAll('.j6csq-decision-tool-slide').forEach(slide => {
        const isVisible = slide.classList.contains('visible') || slide === targetSlide;
        slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
        slide.classList.toggle('visible', isVisible);
    });

    targetSlide.scrollIntoView({ behavior: 'smooth', block: 'start' });
    targetSlide.querySelector('h2')?.focus();

    document.getElementById('live-announcements').textContent =
        `Now viewing slide: ${targetSlide.querySelector('h2')?.textContent || 'Slide'}`;

    document.dispatchEvent(new CustomEvent('slideActivated', { detail: { slideId: targetSlide.id } }));
}

function resetSlide(slide) {

    // Reset the form inputs to their initial values
    const form = slide.querySelector('form');
    if (form) form.reset();

    // Restore original text on interpolated elements
    slide.querySelectorAll('.j6csq-decision-tool-has-interpolated-text').forEach(element => {
        element.innerHTML = element.getAttribute('data-original-text');
    });

    // Remove error messages and classes
    slide.querySelectorAll('.j6csq-decision-tool-error-message').forEach(error => {
        error.hidden = true;
        error.textContent = '';
    });

    slide.querySelectorAll('.j6csq-decision-tool-has-error').forEach(element => {
        element.classList.remove('j6csq-decision-tool-has-error');
    });

    // Remove the completed class which renders as a dashed vertical line
    slide.classList.remove('j6csq-decision-tool-slide-completed');
    slide.style.backgroundPosition = '0 bottom';
}


function validateSlide(slide) {
    let isValid = true;
    let firstInvalidElement = null;

    // Reset previous error messages and remove the error class
    slide.querySelectorAll('.j6csq-decision-tool-error-message').forEach(error => {
        error.hidden = true;
        error.textContent = '';
    });
    slide.querySelectorAll('.j6csq-decision-tool-has-error').forEach(element => {
        element.classList.remove('j6csq-decision-tool-has-error');
    });

    // Validate required inputs and textareas
    slide.querySelectorAll('input[data-j6csq-required], textarea[data-j6csq-required]').forEach(input => {
        if (!input.value.trim()) {
            isValid = false;
            if (!firstInvalidElement) firstInvalidElement = input; // Record first invalid element
            const errorId = input.getAttribute('aria-describedby');
            const error = document.getElementById(errorId);
            if (error) {
                error.hidden = false;
                error.textContent = 'This field is required.';
            }
            input.classList.add('j6csq-decision-tool-has-error'); // Add error class
        }
    });

    // Validate required fieldsets (checkboxes and radios)
    slide.querySelectorAll('fieldset[data-j6csq-required]').forEach(fieldset => {
        const checkboxes = fieldset.querySelectorAll('input[type="checkbox"]');
        const radios = fieldset.querySelectorAll('input[type="radio"]');
        const isCheckboxValid = checkboxes.length && Array.from(checkboxes).some(checkbox => checkbox.checked);
        const isRadioValid = radios.length && Array.from(radios).some(radio => radio.checked);

        if ((!checkboxes.length && !radios.length) || (!isCheckboxValid && !isRadioValid)) {
            isValid = false;
            if (!firstInvalidElement) firstInvalidElement = fieldset; // Record first invalid element
            const errorId = fieldset.getAttribute('aria-describedby');
            const error = document.getElementById(errorId);
            if (error) {
                error.hidden = false;
                error.textContent = 'Please select at least one option.';
            }
            fieldset.classList.add('j6csq-decision-tool-has-error'); // Add error class
        }
    });

    // Scroll to the top of the slide if validation fails
    if (!isValid && firstInvalidElement) {
        slide.scrollIntoView({ behavior: 'smooth', block: 'start' });

        // Optionally focus the first invalid element
        firstInvalidElement.focus();
    }

    return isValid;
}